<div class="flex w-full flex-col bg-white py-2 rounded-xl">
  <div
    class="flex w-full justify-between bg-white py-4 pr-4 border-transparent border-[2px] border-b-gray-300"
  >
    <div class="flex gap-4">
      <div class="h-10 w-1 bg-primary"></div>
      <span>Transaction Flag</span>
    </div>
    <div
      class="p-1 rounded-full h-6 w-6 bg-gray-300"
    (click)="transactionMenu = !transactionMenu"
    >
      <img src="../../../assets/image/Arrows.svg" />
    </div>
  </div>
  <div *ngIf="transactionMenu">
    <form [formGroup]="customerTransactionForm">
      <div class="p-5 gap-4 flex items-center">
        <div class="w-1/2 gap-2 flex flex-col">
          <span>{{ roles | titlecase }} IP</span>

          <!-- Enable Notification By Email, by Phone -->
          <input [readonly]="(roles == 'merchant' || roles == 'reseller' ) && userRole=='admin'"
            formControlName="merchantIp"
            name="merchantIp"
            placeholder="Enter {{ roles | titlecase }} IP"
            class="w-full border p-2 rounded-md outline-none"
          />
        </div>
        <div class="w-1/2 gap-2 flex flex-col">
          <span>{{ roles | titlecase }} PayOut Webhook Url</span>

          <!-- Enable Notification By Email, by Phone -->
          <input [readonly]="(roles == 'merchant' || roles == 'reseller' ) && userRole=='admin'"
            formControlName="payoutWebhookUrl"
            name="payoutWebhookUrl"
            placeholder="Enter Url"
            class="w-full border p-2 rounded-md outline-none"
          />

          <div
            *ngIf="customerTransactionForm.controls['payoutWebhookUrl'].errors?.['pattern']"
            class="text-red-500"
          >
            Invalid URL
          </div>
        </div>
      </div>

      <!-- Auto Settlement -->
      <div
        class="flex w-full justify-between bg-[#F1F1F1] rounded-t-xl py-4 pr-4 border-transparent border-[2px] border-b-gray-300"
      >
        <div class="flex gap-4">
          <div class="h-10 w-1 bg-primary"></div>
          <span>Settlement</span>
        </div>
      </div>
      <div class="flex gap-4 p-5 w-2/3 items-center">
        <div class="flex gap-6 w-full">
          <div class="gap-2 flex w-full my-5">
            <fieldset
              id="settlementType"
              name="settlementType"
              class="flex gap-6 w-full"
            >
              <div class="flex gap-2 items-center">
                <input [readonly]="(singleRole == 'merchant' || singleRole == 'reseller' ) && userRole=='admin'"
                  type="radio"
                  formControlName="settlementType"
                  value="real-time"
                  class="h-5 w-5"
                  name="settlementType"
                />
                <span>Real Time</span>
              </div>
              <div class="flex gap-2 items-center">
                <input [readonly]="(singleRole == 'merchant' || singleRole == 'reseller' ) && userRole=='admin'"
                  type="radio"
                  value="manual"
                  class="h-5 w-5"
                  formControlName="settlementType"
                  name="settlementType"
                />
                <span>Manual</span>
              </div>
              <div class="flex gap-2 items-center">
                <input [readonly]="(singleRole == 'merchant' || singleRole == 'reseller' ) && userRole=='admin'"
                  type="radio"
                  value="custom"
                  formControlName="settlementType"
                  class="h-5 w-5"
                  name="settlementType"
                />
                <span>Custom</span>
              </div>
            </fieldset>
          </div>
        </div>
      </div>
      <div
        *ngIf="
          customerTransactionForm.controls['settlementType'].value == 'custom'
        "
        class="flex gap-4 px-5 w-1/2 items-center my-5"
      >
        <div class="flex w-full flex-col gap-2">
          <span class="text-sm">Settlement Time</span>
          <select class="p-2 border outline-none w-full rounded-md">
            <option hidden disabled selected>Select Settlement Time</option>
            <option>6:00 AM - 7:00 AM</option>
            <option>7:00 AM - 8:00 AM</option>
            <option>8:00 AM - 9:00 AM</option>
            <option>9:00 AM - 10:00 AM</option>
            <option>10:00 AM - 11:00 AM</option>
            <option>11:00 AM - 12:00 PM</option>
            <option>1:00 PM - 2:00 PM</option>
            <option>2:00 PM - 3:00 PM</option>
            <option>3:00 PM - 4:00 PM</option>
            <option>4:00 PM - 5:00 PM</option>
            <option>5:00 PM - 6:00 PM</option>
            <option>6:00 PM - 7:00 PM</option>
            <option>7:00 PM - 8:00 PM</option>
            <option>8:00 PM - 9:00 PM</option>
            <option>9:00 PM - 10:00 PM</option>
          </select>
        </div>
      </div>
    </form>
  </div>
</div>
